import { Component, HostListener, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app',
  template: `
    <div class="dialog">
      <form [formGroup]="form" autocomplete="off">
        <h2 class="dialog-header">{{ data.title | translate }}</h2>

        <div class="dialog-message" *ngIf="data.message">
          <i class="fa fa-exclamation-triangle text-danger"></i>&nbsp;
          {{ data.message | translate }}
        </div>

        <div class="dialog-reason" *ngIf="data.reason">
          <label>{{ data.reason | translate }} <span class="required">*</span></label>
          <textarea
            class="form-control"
            id="reason"
            name="reason"
            formControlName="reason"
            rows="3"
            required
            [ngClass]="{ 'has-error': formSubmitted && f['reason'].errors }"
          ></textarea>
          <div
            *ngIf="(formSubmitted || f['reason'].touched) && f['reason'].errors"
            class="text-danger"
          >
            <div *ngIf="f['reason'].errors['required']">Reason required</div>
          </div>
        </div>

        <div class="dialog-actions">
          <div class="dialog-confirmation" *ngIf="data.requireConfirmation">
            <label class="control control-checkbox">
              <input type="checkbox" name="sure" (change)="confirmCheckBox = !confirmCheckBox" />
              <span>Confirm</span>
              <div class="control-indicator control-inverse"></div>
            </label>
          </div>

          <button class="btn btn-lg" (click)="cancel()">
            <i class="fa fa-close"></i> {{ data.cancelText | translate }}
          </button>
          <button
            class="btn btn-lg btn-primary"
            (click)="confirm()"
            [disabled]="
              (data.reason && form.invalid) || (data.requireConfirmation && !confirmCheckBox)
            "
          >
            <i class="fa fa-check"></i> {{ data.confirmText | translate }}
          </button>
        </div>
      </form>
    </div>
  `,
})
export class ConfirmDialogComponent {
  formSubmitted = false;
  confirmCheckBox = false;

  form = this.formBuilder.group({
    reason: ['', Validators.required],
  });

  constructor(
    private formBuilder: FormBuilder,
    private ref: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  confirm() {
    this.formSubmitted = true;

    if (
      (this.data.reason && this.form.invalid) ||
      (this.data.requireConfirmation && !this.confirmCheckBox)
    ) {
      console.log('Invalid form');

      return;
    }

    this.formSubmitted = false;
    this.form.reset();

    const formData = this.form.value;
    // console.log(formData);
    // if (!formData.reason) {

    const value = formData.reason || true;

    this.ref.close(value); // true
  }

  cancel() {
    this.ref.close(); // false
  }

  @HostListener('keydown.esc')
  onEsc() {
    this.ref.close();
  }
}
// <!-- form.controls['reason'].invalid && (form.controls['reason'].dirty || form.controls['reason'].touched) -->
// data = this.config.data;

// import { DynamicDialogRef } from 'primeng/dynamicdialog';
// import { DynamicDialogConfig } from 'primeng/dynamicdialog';

// private ref: DynamicDialogRef,
// public config: DynamicDialogConfig

// , HostListener, Inject
// import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/*constructor(
    private ref: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      confirmText: string;
      cancelText: string;
      reason: string;
    }
  ) {}

  cancel() {
    this.close(false);
  }

  close(value) {
    this.ref.close(value);
  }

  confirm() {
    this.close(true);
  }

  @HostListener('keydown.esc')
  onEsc() {
    this.close(false);
  }*/

/*template: `
    <span class="cursor pull-right" (click)="cancel()">
      <i class="fa fa-close"></i>
    </span>
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <div mat-dialog-content>
      <p>{{ data.message }}</p>
      <div *ngIf="data.reason">
        <label>{{ data.reason }} <span class="required">*</span> </label>
        <textarea class="form-control" name="reason" ng-model="reason" required></textarea>
        <!-- <div
          class="error-messages"
          ng-if="vm.UtilService.interacted(form.reason)"
          ng-messages="form.reason.$error"
        >
          <div ng-message="required">{{ 'REQUIRED_FIELD' | translate }}</div>
        </div> -->
      </div>
    </div>
    <div mat-dialog-actions align="end">
      <button class="btn btn-lg" style="margin-right:10px;" (click)="cancel()">
        <!-- <i class="fa fa-close"></i> -->
        {{ data.cancelText }}
      </button>
      <button class="btn btn-primary btn-lg" (click)="confirm()">
        <!-- <i class="fa fa-check"></i> -->
        {{ data.confirmText }}
      </button>
    </div>
  `,*/
